<template>
  <div class="Quantity">
    <button :disabled="quantity <= step" @click="decrement()"><IconBase iconName="remove"><IconMinus /></IconBase></button>
    <input :readonly="step !== 1" type="number" v-model="quantity" />
    <button @click="increment()"><IconBase iconName="add"><IconAdd /></IconBase></button>
  </div>
</template>

<script>
import IconAdd from "./icons/IconAdd";
import IconMinus from "./icons/IconMinus";

export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    step: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      quantity: 0
    };
  },
  watch: {
    quantity(newValue, oldValue) {
      this.$emit("input", parseInt(newValue));
    }
  },
  methods: {
    increment() {
      this.quantity = parseInt(this.quantity) + this.step;
    },
    decrement() {
      if (parseInt(this.quantity) > this.step) {
        this.quantity -= this.step;
      }
    }
  },
  created() {
    this.quantity = this.value;
  },
  components: { IconAdd, IconMinus }
};
</script>

<style lang="scss" scoped>
@import '../assets/variables';

.Quantity {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  color: inherit;

  input {
    border: 0;
    width: 4em;
    text-align: center;
    padding: 0 0.5em;
    font-family: $primary-font;
    font-weight: 600;
    background: none;
    color: inherit;
    font-size: inherit;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  input[readonly] {
    cursor: default;
  }

  input:hover {
    outline: 1px solid $color-primary;
  }

  input:hover[readonly] {
    outline: none;
  }

  input:focus[readonly] {
    outline: none;
  }

  button {
    background: none;
    border: 0;
    color: inherit;
    cursor: pointer;

    &:disabled {
      opacity: 0.5;
      cursor: default;
    }
  }
}
</style>
